<template>
    <div class="thankyou">
        <v-container class="content-container pa-5">
        <v-row>
            <v-col cols="12 text-center column">
                <h1 class="">Thank You!</h1>
                <h3>Your Application Has Been Submitted Successfully.!!</h3>

                <v-btn small class="mt-3 next-btn appBlue white--black" @click="goBack()">Back to Login</v-btn>
            </v-col>
        </v-row>
        </v-container>
        
    </div>
</template>

<script>
export default {

    methods:{
        goBack(){
            this.$router.push({ name: "signin" });
        }
    },
}
</script>
<style scoped>
 .content-container{
margin-top: 200px;
 }

 .column h1 {
     font-size: 60px;
 }
 .column h3{
     font-size: 20px;
     color: #919191;
     margin-bottom:30px;
 }
.adjust-back-login-btn{
    width: 140px !important;
}
</style>